import { Role } from "@/router/_helper";

const meetSettings = {
  path: "/settings/meet",
  name: "meetSettings",
  component: () =>
    import(/* webpackChunkName: "meetSettings" */ "@/views/MeetSettings.vue"),
  meta: { authorize: [Role.ManageSettings], requiresAuth: true },
};

export default meetSettings;
